export function initializeCard(payments, elementSelector) {
  return new Promise((resolve, reject) => {
    payments
      .card()
      .then(card => {
        return card.attach(elementSelector).then(() => {
          resolve(card)
        })
      })
      .catch(reject)
  })
}

export function tokenize(paymentMethod) {
  return new Promise((resolve, reject) => {
    paymentMethod
      .tokenize()
      .then(tokenResult => {
        if (tokenResult.status === 'OK') {
          resolve(tokenResult.token)
        } else {
          let errorMessage = `Tokenization failed with status: ${tokenResult.status}`
          if (tokenResult.errors) {
            errorMessage += ` and errors: ${JSON.stringify(tokenResult.errors)}`
          }

          reject(new Error(errorMessage))
        }
      })
      .catch(reject)
  })
}

export function createSquarePayment(token, locationId, amount) {
  console.log('token recieved', token, locationId)
  return new Promise((resolve, reject) => {
    const body = JSON.stringify({
      locationId,
      sourceId: token,
      amount
    })

    fetch('api/rooms/submitPaymentAndBookRoom', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    })
      .then(paymentResponse =>
        paymentResponse.json(console.log('res1', paymentResponse))
      )
      .then(res => {
        console.log('res2', res)
        resolve(res)
      })
      .catch(reject)
  })
}



// WEBPACK FOOTER //
// ./src/utils/clientPaymentUtils.js